import React from "react";
import Layout from "../components/Layout/Layout";
import SignalLayout from "../components/signal/SignalLayout";

const Signals = () => {
  return (
    <Layout>
      <SignalLayout />
    </Layout>
  );
};

export default Signals;
